module.exports = __webpack_public_path__ + "img/13.63c5eb86.png";